import { Component, Input } from '@angular/core';
import { AutoCompleteSearchDropdownOptionsI } from '../autocomplete-field/autocomplete-field.interface';

@Component({
  selector: 'app-not-in-model-field',
  templateUrl: './not-in-model-field.component.html',
  styleUrls: ['./not-in-model-field.component.scss']
})
export class NotInModelFieldComponent {
  @Input('lob') lob: string;

  controlName = 'not_in_model';

  autoCompleteFieldOptions: AutoCompleteSearchDropdownOptionsI;

  cvAutoCompleteFieldOptions: AutoCompleteSearchDropdownOptionsI = {
    searchApiUrl: '/services/api/v1/rb_masters/get-model-by-name?lob=cv',
    dataApiUrl: '/services/api/v1/rb_masters/get-all-models?lob=cv',
    queryParamKey: 'model_name',
    dataIdKey: 'rb_id',
    dataNameKey: 'model_name',
  }

  motorAutoCompleteOptions: AutoCompleteSearchDropdownOptionsI = {
    searchApiUrl: `/services/api/v1/rb_masters/get-model-by-name?lob=motor`,
    dataApiUrl: '/services/api/v1/rb_masters/get-all-models?lob=motor',
    queryParamKey: 'model_name',
    dataIdKey: 'rb_id',
    dataNameKey: 'model_name',
  }

  ngOnInit() {
    if (this.lob == 'cv') {
      this.autoCompleteFieldOptions = this.cvAutoCompleteFieldOptions;
    } else {
      this.autoCompleteFieldOptions = this.motorAutoCompleteOptions;
    }
  }
}
